var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9027 1.79412H10.2557H9.6086V0.5H10.9027V1.79412ZM10.2557 1.79412C6.3319 1.79412 3.13802 5.05788 3.13802 9.07094V13.3312C3.13802 15.7041 1.49726 17.425 1.43413 17.4912L1.43237 17.4931L0.341431 18.5969H20.2152L19.0712 17.4853C19.0531 17.4685 17.3733 15.8107 17.3733 13.3312V9.07094C17.3733 5.05788 14.1794 1.79412 10.2557 1.79412ZM4.43213 13.3312C4.43213 15.02 3.7799 16.4073 3.20531 17.3028H17.2931C16.7198 16.4151 16.0792 15.0394 16.0792 13.3312V9.07094C16.0792 5.77224 13.4664 3.08824 10.2557 3.08824C7.04496 3.08824 4.43213 5.77224 4.43213 9.07094V13.3312ZM12.1968 18.6176H10.9027C10.9027 18.9748 10.6116 19.2647 10.2557 19.2647C9.89978 19.2647 9.6086 18.9748 9.6086 18.6176H8.31449C8.31449 19.6879 9.18543 20.5588 10.2557 20.5588C11.3259 20.5588 12.1968 19.6879 12.1968 18.6176Z",
    fill: "#697E8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.4c3d577d55161d006c41701389b532fb.svg";
export { ForwardRef as ReactComponent };